import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../Core/Components/CustomInput";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { TRIP_CONTAINER_TYPE } from "../Data/TripConstants";

const getContainerType = (tripDetails) => {
  let canister = false;
  let crate = false;

  if (tripDetails?.containerType === TRIP_CONTAINER_TYPE.BOTH) {
    canister = true;
    crate = true;
  }

  if (tripDetails?.containerType === TRIP_CONTAINER_TYPE.CANISTER) {
    canister = true;
    crate = false;
  }

  if (tripDetails?.containerType === TRIP_CONTAINER_TYPE.CRATE) {
    canister = false;
    crate = true;
  }

  return { canister, crate };
};

const TripStep2ContainerSide = () => {
  const dispatch = useDispatch();

  const { tripDetails, validationForSteps } = useSelector(
    (state) => state.trips,
  );

  const [focus, setFocus] = useState({
    canisters: false,
    crates: false,
  });

  const { canister: hasCanister, crate: hasCrate } =
    getContainerType(tripDetails);

  const canisters = tripDetails?.canisters ?? 0;
  const crates = tripDetails?.crates ?? 0;

  const canisterError = validationForSteps?.step2?.canisters;
  const crateError = validationForSteps?.step2?.crates;

  const updateCount = (type, value) => {
    dispatch(
      updateTrips({
        key: "tripDetails",
        value: { ...tripDetails, [type]: value },
      }),
    );

    dispatch(
      updateTrips({
        key: "validationForSteps",
        value: {
          ...validationForSteps,
          step2: {
            ...validationForSteps.step2,
            [type]: false,
          },
        },
      }),
    );
  };

  const getBorder = (type) => {
    if (type === "canisters" && hasCanister) {
      if (canisterError) return "error";
      if (focus?.canisters) return "success";
      return "primary";
    }

    if (type === "crates" && hasCrate) {
      if (crateError) return "error";
      if (focus?.crates) return "success";
      return "primary";
    }

    return "primary";
  };

  return (
    <div className="w-[50%] px-6">
      <p className="text-xs font-poppins font-medium text-black">
        Assign Containers
      </p>

      {/* canisters */}
      {hasCanister && (
        <div>
          <p className="mt-6 text-xs font-poppins font-medium text-black">
            Canisters
          </p>

          <p className="mt-2 mb-1.5 text-xs font-aileron font-normal text-dark-gray">
            How many canisters would be needed for this trip?
          </p>

          <CustomInput
            intent="tripStep2"
            placeholder="Enter no. of canisters"
            value={tripDetails?.canisters}
            border={getBorder("canisters")}
            onFocus={() => setFocus((prev) => ({ ...prev, canisters: true }))}
            onBlur={() => setFocus((prev) => ({ ...prev, canisters: false }))}
            onChange={(e) => updateCount("canisters", e.target.value)}
          />

          {canisterError && (
            <p className="mt-1.5 text-xs font-normal font-aileron text-alert-red">
              Enter a valid value to proceed
            </p>
          )}

          <div className="mt-2 flex items-center gap-x-2 w-[416px]">
            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              canisters === 2
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("canisters", 2)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                2
              </p>
            </div>

            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              canisters === 4
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("canisters", 4)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                4
              </p>
            </div>

            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              canisters === 8
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("canisters", 8)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                8
              </p>
            </div>

            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              canisters === 10
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("canisters", 10)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                10
              </p>
            </div>
          </div>
        </div>
      )}

      {/* crates */}
      {hasCrate && (
        <div>
          <p className="mt-6 text-xs font-poppins font-medium text-black">
            Crates
          </p>

          <p className="mt-2 mb-1.5 text-xs font-aileron font-normal text-dark-gray">
            How many crates would be needed for this trip?
          </p>

          <CustomInput
            intent="tripStep2"
            placeholder="Enter no. of crates"
            value={tripDetails?.crates}
            border={getBorder("crates")}
            onFocus={() => setFocus((prev) => ({ ...prev, crates: true }))}
            onBlur={() => setFocus((prev) => ({ ...prev, crates: false }))}
            onChange={(e) => updateCount("crates", e.target.value)}
          />

          {crateError && (
            <p className="mt-1.5 text-xs font-normal font-aileron text-alert-red">
              Enter a valid value to proceed
            </p>
          )}

          <div className="mt-2 flex items-center gap-x-2 w-[416px]">
            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              crates === 2
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("crates", 2)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                2
              </p>
            </div>

            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              crates === 4
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("crates", 4)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                4
              </p>
            </div>

            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              crates === 8
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("crates", 8)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                8
              </p>
            </div>

            <div
              role="button"
              className={`flex-1 rounded-md h-8 flex items-center justify-center
            ${
              crates === 10
                ? "bg-primary text-white"
                : "bg-primary-10 text-primary"
            }
            `}
              onClick={() => updateCount("crates", 10)}
            >
              <p className="text-xs font-poppins font-medium leading-[100%]">
                10
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TripStep2ContainerSide;
